import { j as r } from "../../../jsx-runtime-B6kdoens.js";
import { a as u } from "../../../index-CROKJrb5.js";
import { c as l, f as d } from "../../../create-component-CBAeEoQ6.js";
const h = l(
  "IngredientTile",
  d(
    ({ as: e, className: c, abbreviation: t, description: o, ingredient: s, ...n }, a) => {
      const i = e || "div", m = u(
        "cur-flex cur-flex-col cur-border-y-2 cur-border-l-2 last:cur-border-r-2 cur-border-white cur-text-white cur-p-4 cur-w-[11.085rem] cur-min-h-min cur-flex-nowrap",
        c
      );
      return /* @__PURE__ */ r.jsxs(i, { ref: a, className: m, ...n, children: [
        /* @__PURE__ */ r.jsx("div", { className: "cur-font-display cur-text-[6rem] cur-font-bold cur-leading-[.9em]", children: t }),
        /* @__PURE__ */ r.jsx("div", { className: "cur-text-[1.25rem] cur-font-bold", children: s }),
        /* @__PURE__ */ r.jsx("div", { className: "cur-mt-auto cur-text-meta cur-leading-[1em]", children: o })
      ] });
    }
  )
);
export {
  h as IngredientTile
};
//# sourceMappingURL=index.js.map
